import { render, staticRenderFns } from "./defined-role-selector.vue?vue&type=template&id=541f3579&"
import script from "./defined-role-selector.vue?vue&type=script&lang=ts&"
export * from "./defined-role-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports